
const VUE_APP_ApiHost = process.env.VUE_APP_ApiHost
const VUE_APP_WebHost = process.env.VUE_APP_WebHost

export default {
  host: VUE_APP_ApiHost,
  webHost: VUE_APP_WebHost
}
